import { AppService } from "./app.service";
import { Router } from "@angular/router";
var AdminRoleGuard = (function () {
    function AdminRoleGuard(appService, router) {
        this.appService = appService;
        this.router = router;
    }
    AdminRoleGuard.prototype.canActivate = function () {
        if (this.appService.getCurrentUser().role == 'ADMIN') {
            return true;
        }
        return false;
    };
    return AdminRoleGuard;
}());
export { AdminRoleGuard };



// WEBPACK FOOTER //
// /build/client-cms/src/app/admin-role.guard.ts.pre-build-optimizer.js